'use strict';

var React = require('react'),
    classNames = require('classnames'),
    ApplicationActions = require('js/shared/actions/application-actions.js'),
    _ = require('underscore');

var ApplicationStepIndicator = React.createClass({

  propTypes: {
    stepCount: React.PropTypes.number.isRequired,
    currentStep: React.PropTypes.number,
    stepsCompleted: React.PropTypes.number.isRequired
  },

  getDefaultProps: function() {
    return {
      currentStep: -1
    };
  },

  _onClickDot: function(stepIndex) {
    return function() {
      ApplicationActions.changeQuestionPage(stepIndex);
    }
  },

  _renderStep: function(stepIndex) {
    var classes = classNames({
      'ApplicationStepIndicator-step': true,
      'ApplicationStepIndicator-step--active': stepIndex === this.props.currentStep,
      'ApplicationStepIndicator-step--completed': stepIndex <= this.props.stepsCompleted,
    });

    return (
      <div
        key={stepIndex}
        className={classes}
        onClick={this._onClickDot(stepIndex)}></div>
    );
  },

  render: function() {
    var $this = this;
    return (
      <div
        className="ApplicationStepIndicator">
        {_.map(_.range(this.props.stepCount), _.bind(this._renderStep, this))}
      </div>
    );
  }
});

module.exports = ApplicationStepIndicator;



/** WEBPACK FOOTER **
 ** ./js/screens/form/application-step-indicator.jsx
 **/